import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

type Props = {
  readonly server?: string;
  readonly schema?: string;
  readonly commitId?: string;
};

export const NewDeploymentSummary = (props: Props) => {
  const { server, schema, commitId } = props;

  return (
    <>
      <Grid container style={{ margin: '40px 0' }}>
        <Grid item xs={12}>
          <Typography variant="h6">Deployment summary</Typography>
        </Grid>
        <Grid item xs={12} style={{ margin: '20px 0' }}>
          <Typography>Server: {server}</Typography>
          <Typography>Schema: {schema}</Typography>
          <Typography>CommitId: {commitId}</Typography>
        </Grid>
        <Grid item xs={12} display="flex" justifyContent="center">
          <Typography>Are you sure you want to deploy this configuration?</Typography>
        </Grid>
      </Grid>
    </>
  );
}

export default NewDeploymentSummary;
